var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "v-snackbar",
        {
          key: index,
          attrs: {
            top: item.y === "top",
            bottom: item.y === "bottom",
            left: item.x === "left",
            right: item.x === "right",
            color: item.color,
            timeout: item.timeout,
            outlined: item.outlined,
            absolute: item.absolute || false,
            "multi-line": item.multiline,
            vertical: item.vertical,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "action",
                fn: function ({ attrs }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._b(
                        {
                          attrs: { dark: !item.outlined, text: "" },
                          on: {
                            click: function ($event) {
                              item.state = false
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      [_vm._v(" " + _vm._s(item.closeBtnText || "Close") + " ")]
                    ),
                  ]
                },
              },
            ],
            null,
            true
          ),
          model: {
            value: item.state,
            callback: function ($$v) {
              _vm.$set(item, "state", $$v)
            },
            expression: "item.state",
          },
        },
        [_vm._v(" " + _vm._s(item.text) + " ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }